export var GovtBenefitTypes;
(function (GovtBenefitTypes) {
    GovtBenefitTypes["FamilyTax"] = "FAMILY_TAX";
    GovtBenefitTypes["AgePension"] = "AGE_PENSION";
    GovtBenefitTypes["DisabilitySupportPension"] = "DISABILITY_SUPPORT_PENSION";
    GovtBenefitTypes["Other"] = "OTHER";
})(GovtBenefitTypes || (GovtBenefitTypes = {}));
//# sourceMappingURL=GovtBenefitTypes.js.map